import {
  faCircleCheck,
  faCircleXmark,
} from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "src/design-system/Icon";
import { Pill } from "src/design-system/Pill";

type ChatToolResultProps = {
  toolName: string;
  isSuccess: boolean;
  message: string;
  dataLoc?: string;
};

export const ChatToolResult: React.FC<ChatToolResultProps> = ({
  toolName,
  isSuccess,
  message,
  dataLoc,
}) => (
  <div
    className="flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-2"
    data-loc={dataLoc}
  >
    <div className="flex items-center gap-x-2">
      <Icon
        icon={isSuccess ? faCircleCheck : faCircleXmark}
        size="sm"
        variant={isSuccess ? "success" : "error"}
      />
      <Pill size="sm" variant="gray">
        <span className="font-mono text-xs">{toolName}</span>
      </Pill>
      <span className="font-inter-normal-12px text-gray-600">{message}</span>
    </div>
  </div>
);
